import { compose } from 'redux';
import { connect } from 'react-redux';
import * as Actions from '../../../actions/AdminCompanyManagement';
import CompanyManagementSelector from '../../../selectors/AdminCompanyManagement';
import withAuth from '../../../common/WithAuth';
import ListSeminar from '../../../pages/Admin/CompanyManagement/ListSeminar';
import { callApiGetInformationRoom } from '../../../actions/RegistrationOrganizer';

const detailCompanySelector = CompanyManagementSelector.createDetailCompanySelector();
const mapStateToProps = (state) => {
    const isLoading = state.adminCompanyManagement.listSeminar.isFetching
    || state.adminCompanyManagement.detailCompany.isFetching
    || state.adminCompanyManagement.detailSeminar.isFetching
    || state.adminCompanyManagement.updateSeminar.isFetching
    || state.registration.registrationViewer.isFetching
    || state.registrationOrganizer.registrationOrganizer.isFetching
    || state.adminCompanyManagement.deleteSeminar.isFetching;

    return ({
        listSeminar: state.adminCompanyManagement.listSeminar.data.results,
        detailCompany: detailCompanySelector(state),
        seminarDetail: state.adminCompanyManagement.detailSeminar.data,
        eventInfo: state.eventManagement.infoEvent.data,
        seminars: state.adminCompanyManagement.listSeminar.data,
        detailSeminar: state.adminCompanyManagement.detailSeminar.data,
        detailSeminarErrors: state.adminCompanyManagement.detailSeminar.errors,
        updateSeminarSuccess: state.adminCompanyManagement.updateSeminar.updateSeminarSuccess,
        deleteSuccessSeminar: state.adminCompanyManagement.deleteSeminar.deleteSuccessSeminar,
        deleteErrorSeminar: state.adminCompanyManagement.deleteSeminar.errors,
        errors: state.adminCompanyManagement.updateSeminar.errors,
        isFetchingUpdate: state.adminCompanyManagement.updateSeminar.isFetching,
        percent: state.adminCompanyManagement.updateSeminar.percent,
        room: state.registrationOrganizer.registrationOrganizer.room,
        token: state.auth.credential.data.token,
        isLoading,
    });
};

const mapDispatchToProps = (dispatch) => ({
    fetchListSeminar: (params) => {
        dispatch(Actions.GetListSeminarRequested(params));
    },
    updateSeminar: (params) => {
        dispatch(Actions.UpdateSeminarRequested(params));
    },
    getDetailCompany: (params) => {
        dispatch(Actions.GetDetailCompanyRequested(params));
    },
    getDetailSeminar: (params) => {
        dispatch(Actions.GetDetailSeminarRequested(params));
    },
    getInformationRoom: (params) => {
        dispatch(callApiGetInformationRoom(params));
    },
    clearDetailComopany: () => {
        dispatch(Actions.ClearGetDetailCompany());
    },
    deleteSeminar: (params) => {
        dispatch(Actions.callApiDeleteSeminarOfCompany(params));
    },
    clearDeleteSeminar: () => {
        dispatch(Actions.clearCallApiDeleteSeminarOfCompany());
    },
    clearSeminar: () => {
        dispatch(Actions.ClearListSeminar());
    },
    clearUpdateSeminar: () => {
        dispatch(Actions.ClearSeminar());
    },
    clearDetailSeminar: () => {
        dispatch(Actions.ClearDetailSeminar());
    },
});

export default compose(
    withAuth,
    connect(
        mapStateToProps,
        mapDispatchToProps,
    ),
)(ListSeminar);
